const POPUP_WINDOW_OPTIONS = "height=700,width=980,scrollbars=yes";

// Create the popup window and return the new window object ref.
// If the window cannot be created (is blocked) then null is returned.
// See https://developer.mozilla.org/en-US/docs/Web/API/Window/open#Return_value
export const createPopupWindow = (url: string) =>
  window.open(url, "_blank", POPUP_WINDOW_OPTIONS);

export const createConnectPopup = (url: string): Window => {
  const popup = createPopupWindow(url);

  // When popups are blocked by the browser `popup` will be falsey
  // so we return early here.
  if (!popup) {
    throw new Error("Popup was blocked.");
  }

  return popup;
};
